<template>
    <span class="JobStatus">
        <span v-if="status === 'applied'"> <i class="fa fa-envelope"></i> Anmodet </span>
        <span v-else-if="status === 'accepted'"> <i class="fa fa-thumbs-up"></i> Accepteret </span>
        <span v-else-if="status === 'started'"> <i class="fa fa-cogs"></i> Påbegyndt </span>
        <span v-else-if="status === 'finished'"> <i class="fa fa-check"></i> Afsluttet </span>
        <span v-else-if="status === 'cancelled'"> <i class="fa fa-times"></i> Afbrudt </span>
        <span v-else-if="status === 'declined'"> <i class="fa fa-times"></i> Afvist </span>
    </span>
</template>

<style>
.JobStatus .fa {
    margin-right: 5px;
}
</style>

<script type="text/babel">
export default {
    props: ['status'],
}
</script>
